import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProjectsService } from 'src/app/services/projects.service';
import { MainService } from 'src/app/services/main.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-project-diagramation-images',
  templateUrl: './project-diagramation-images.component.html',
  styleUrls: ['./project-diagramation-images.component.scss']
})
export class ProjectDiagramationImagesComponent implements OnInit {

  dataImages: any = [];
  //type 1 para vobo y 2 para diagramacion
  type: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private projectsS: ProjectsService,
    private main : MainService
  ) { }

  ngOnInit(): void {
    this.type = this.data.type
    this.getImages();
  }

  getImages(){
    this.main.ShowLoading();

    this.projectsS.getImagesDiagramation(this.data.id,this.type).subscribe(
              (result:any) => {
                this.dataImages = result.data;
                this.main.HideLoading();
              },
              (err:any) => {
                console.log(err);
                Swal.fire({
                  icon: 'error',
                  title: 'Error al obtener imágenes',
                  text: 'Ocurrió un error al obtnener las imágenes, por favor vuelve a intentarlo.'
                });
              }
            );

  }


  deleteImage(id: number){
    this.main.ShowLoading();
    
    this.projectsS.deleteImageDiagramation(id,this.type).subscribe(
              (result:any) => {
                if(result.message == "Success") {
                              Swal.fire({
                                icon: 'success',
                                title: 'Eliminado',
                                text: 'Eliminado correctamente'          
                              }).then(() => {   
                                Swal.close();         
                                this.getImages();
                              });
                              this.main.HideLoading();
                            }
                            else {
                              Swal.fire({
                                icon: 'error',
                                title: 'Error al eliminar',
                                text: 'Ocurrió un error al eliminar el registro, por favor vuelve a intentarlo.'
                              });
                            }
              },
              (err:any) => {
                console.log(err);
                Swal.fire({
                  icon: 'error',
                  title: 'Error al obtener imágenes',
                  text: 'Ocurrió un error al obtnener las imágenes, por favor vuelve a intentarlo.'
                });
              }
            );
  }

}
